// extracted by mini-css-extract-plugin
export default {"free-demo-button":"css_free-demo-button__n6LTs","alone-button":"css_alone-button__M3JUa","large":"css_large__AoqmN","mobile":"css_mobile__8W4OV"};